export interface AnimationState {
  scale: number;
  opacity: number;
}

export enum AnimationPreset {
  // Basic presets
  GENTLE = 'gentle',
  DEFAULT = 'default',
  SNAPPY = 'snappy',
  BOUNCY = 'bouncy',
  // Advanced presets for animation components
  SLOT_BOUNCE = 'slotBounce',
  WAVE_TEXT = 'waveText',
  FLIP_3D = 'flip3D',
  ELASTIC = 'elastic',
  GLOW = 'glow',
  TEXT_SLIDE = 'textSlide',
  CONTAINER = 'container',
}

/**
 * Configuration for staggered animations
 */
export interface AnimationConfig {
  /** Starting frame for animation (default: 0) */
  startFrame?: number;
  /** Delay between elements in frames (default: 10) */
  stagger?: number;
  /** Spring configuration to use */
  springConfig?: AnimationPreset;
}
